import { useState } from 'react';
import { useMutation } from '@apollo/client';
import useDebounceMutation from 'components/common/hooks/useDebounceUpdate';
import UPDATE_WAREHOUSE_RELEASE_REMARKS from 'api/mutations/UPDATE_WAREHOUSE_RELEASE_REMARKS';
import UPDATE_WAREHOUSE_RELEASE_RECEIVER from 'api/mutations/UPDATE_WAREHOUSE_RELEASE_RECEIVER';
export default function useSummary(warehouseRelease) {
    const [remarks, setRemarks] = useState((warehouseRelease === null || warehouseRelease === void 0 ? void 0 : warehouseRelease.remarks) ? warehouseRelease === null || warehouseRelease === void 0 ? void 0 : warehouseRelease.remarks : '');
    const [updateRemarks] = useMutation(UPDATE_WAREHOUSE_RELEASE_REMARKS);
    const [debounceUpdate] = useDebounceMutation(500);
    const handleRemarksChange = (e) => {
        setRemarks(e.target.value);
        debounceUpdate(updateRemarks, { warehouseReleaseNodeId: warehouseRelease.id, remarks: e.target.value });
    };
    const [receiver, setReceiver] = useState((warehouseRelease === null || warehouseRelease === void 0 ? void 0 : warehouseRelease.receiver) ? warehouseRelease === null || warehouseRelease === void 0 ? void 0 : warehouseRelease.receiver : '');
    const [updateReceiver] = useMutation(UPDATE_WAREHOUSE_RELEASE_RECEIVER);
    const handleReceiverChange = (e) => {
        setReceiver(e.target.value);
        debounceUpdate(updateReceiver, { warehouseReleaseNodeId: warehouseRelease.id, receiver: e.target.value });
    };
    return {
        description: remarks,
        receiver: receiver,
        onDescriptionChange: handleRemarksChange,
        onReceiverChange: handleReceiverChange
    };
}
